module.exports = __webpack_public_path__ + "media/images/menu/juno-31eccd0db8c7e22e71a3f5e3ae6e64c7.jpg";